// @flow

import React, { useRef, useMemo } from "react";

import usePopoverScroll from "src/hooks/usePopoverScroll";
import Options from "./Options/Single";
import Standard from "src/components/Unifize/Status/Standard";
import Custom from "src/components/Unifize/Status/Custom";
import { Status as StyledStatus } from "src/components/Unifize/Status/styles";
import useDropdown from "src/hooks/useDropdown";
import { useSelector } from "react-redux";
import {
  getChatroomStatus,
  getDueDate,
  getTemplateId,
  getActiveStatus,
} from "src/reducers";
import moment from "moment";
import type { RoomId, ColumnId } from "src/types";

type Props = {
  index: number,
  selected: boolean,
  roomId: RoomId,
  value: number,
  depth: number,
  parentId: number,
  columnId: ?ColumnId,
  fieldWidth?: string,
};

const Status = ({
  value,
  roomId,
  selected,
  index,
  depth,
  parentId,
  columnId,
  fieldWidth,
}: Props) => {
  const outerRef = useRef(null);
  const { dropdown: isOpen, toggleDropdown } = useDropdown(outerRef);

  usePopoverScroll({
    isOpen,
    parentContainerRef: outerRef,
    handleClose: toggleDropdown,
  });

  const dueDate = useSelector(({ app }) => getDueDate(app, roomId));
  const templateId = useSelector(({ app }) => getTemplateId(app, roomId));
  const id = useSelector(({ app }) => getChatroomStatus(app, roomId));
  const activeStatus = useSelector(({ app }) =>
    getActiveStatus(app, templateId, id),
  );

  const overdue = useMemo(() => {
    const days = moment(dueDate)
      .startOf("day")
      .diff(moment().startOf("day"), "days");
    return days < 0;
  }, [dueDate]);

  // $FlowFixMe - Optional chaining not supported
  const statusLabelWidth = parseInt(fieldWidth?.split("px")[0], 10) - 18 + "px";

  return (
    <StyledStatus>
      <div
        ref={outerRef}
        tabIndex="0"
        role="button"
        onClick={toggleDropdown}
        style={{
          maxWidth: statusLabelWidth,
          overflow: "hidden",
        }}
      >
        {value < 0 ? (
          <Standard
            id={value}
            roomId={roomId}
            isOverDue={overdue}
            active={activeStatus}
          />
        ) : (
          <Custom
            id={value}
            roomId={roomId}
            isOverDue={overdue}
            active={activeStatus}
          />
        )}
      </div>

      <Options
        selected={selected}
        roomId={roomId}
        index={index}
        handleClose={toggleDropdown}
        show={isOpen}
        depth={depth}
        parentId={parentId}
        columnId={columnId}
      />
    </StyledStatus>
  );
};

export default Status;
